import React, { ReactNode } from "react";

import { Flex, SkeletonWrapper, Steps, Typography } from "components";

export type StepType = {
  title?: ReactNode;
  description?: ReactNode;
  status?: "wait" | "process" | "finish" | "error";
  disabled?: boolean;
  icon?: ReactNode;
};

export type StepsWidgetProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  description?: ReactNode;
  steps: StepType[];
  currentStep: number;
  className?: string;
  direction?: "horizontal" | "vertical";
  labelPlacement?: "horizontal" | "vertical";
  children?: ReactNode;
  isLoading?: boolean;
};

export const StepsWidget = ({
  title,
  subtitle,
  description,
  steps,
  currentStep,
  className = "",
  direction,
  labelPlacement,
  children,
  isLoading,
}: StepsWidgetProps) => {
  const stepsClassName = direction === "horizontal" ? "margin-top-75 klim-steps klim-steps-horizontal" : "margin-top-75 klim-steps klim-steps-vertical";

  return (
    <>
      <Flex vertical gap={12} className={className}>
        <SkeletonWrapper className="skeleton-rectangular" height="1rem" width="25%" type="block" isLoading={isLoading}>
          {subtitle && (
            <Typography variant="h6" className="steps-widget-subtitle">
              {subtitle}
            </Typography>
          )}
        </SkeletonWrapper>
        <SkeletonWrapper className="skeleton-rectangular" height="2.5rem" width="45%" type="block" isLoading={isLoading}>
          {title && <Typography variant="h1">{title}</Typography>}
        </SkeletonWrapper>
        <SkeletonWrapper className="skeleton-rectangular" rows={3} width="90%" type="paragraph" isLoading={isLoading}>
          {description && (
            <Typography variant="paragraph-m" className="margin-top-75 steps-widget-description">
              {description}
            </Typography>
          )}
        </SkeletonWrapper>
        <SkeletonWrapper className="skeleton-rectangular" rows={6} width="40%" type="paragraph" isLoading={isLoading}>
          <Steps current={currentStep} items={steps} className={stepsClassName} direction={direction} labelPlacement={labelPlacement} />
        </SkeletonWrapper>
      </Flex>
      <SkeletonWrapper className="skeleton-rectangular" height="1.5rem" width="40%" type="block" isLoading={isLoading}>
        <Flex>{children}</Flex>
      </SkeletonWrapper>
    </>
  );
};

export default StepsWidget;
